import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { finalize, map, tap } from 'rxjs';
import { ClassStudentStatsHttpService } from './class-student-stats-http.service';
import { ClassStudentStatsStoreModel } from './class-student-stats.model';
import { ClassStudentStatsStore } from './class-student-stats.store';

@Injectable({ providedIn: 'root' })
export class ClassStudentStatsService {
  constructor(
    private readonly store: ClassStudentStatsStore,
    private readonly http: ClassStudentStatsHttpService,
    private readonly errorHandler: ErrorHandlerService,
  ) {}

  fetchByClassId(
    classId: string,
    { resetStore, showLoading }: { resetStore?: boolean; showLoading?: boolean } = { resetStore: false },
  ) {
    if (resetStore) {
      this.store.reset();
    }

    if (resetStore || showLoading) {
      this.store.setLoading(true);
    }

    return this.http.fetchByClassId(classId).pipe(
      this.errorHandler.setHttpErrorMetadata({ entity: 'class_student_stats', action: 'fetch' }),
      map((rows) => rows.map((row) => this.mapToStoreModel(row))),
      tap((rows) => (resetStore ? this.store.set(rows) : this.store.upsertMany(rows))),
      finalize(() => {
        if (resetStore || showLoading) {
          this.store.setLoading(false);
        }
      }),
    );
  }

  resetStore() {
    this.store.reset();
  }

  private mapToStoreModel(httpModel: Omit<ClassStudentStatsStoreModel, 'id'>): ClassStudentStatsStoreModel {
    return {
      ...httpModel,
      id: `${httpModel.class_id}__${httpModel.student_id}`,
    };
  }
}
